export default __webpack_public_path__ + "static/media/dog@2x.524624eb.png";